module.exports = __webpack_public_path__ + "static/media/add_task_icon.d75c149f.svg";